import styled, { css } from 'styled-components'
import { theme } from 'styles/theme/hav-theme'

type DividerProps = {
  orientation?: 'horizontal' | 'vertical'
  marginTop?: string
  marginLeft?: string
  marginRight?: string
  marginBottom?: string
  length?: string
  thickness?: string
}

export const Divider = styled.div<DividerProps>`
  background-color: ${theme.colors.ion.state.enabled.borderneutral};

  ${({
    orientation = 'horizontal',
    marginTop = '0',
    marginRight = '0',
    marginBottom = '0',
    marginLeft = '0',
    length = '100%',
    thickness = '1px',
  }) =>
    orientation === 'horizontal'
      ? css`
          width: ${length};
          height: ${thickness};
          margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft};
        `
      : css`
          width: ${thickness};
          height: ${length};
          margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft};
        `}
`
